import { styled } from "@woba/ds-web";

export const Wrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  cursor: "pointer",
  userSelect: "none",
  gap: "$space-03",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "20px",
  color: "$neutral-900",
  backgroundColor: "white",
  padding: "$space-04",

  "&[data-highlighted]": {
    backgroundColor: "$neutral-200",
  },

  span: {
    fontWeight: "bold",
  },
});

export const InputWrapper = styled("div", {
  p: {
    color: "$danger-500",
    marginTop: "$space-02",
    fontSize: "$sm",
  },
});
